var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineArchiveSlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.47 22.53a.754.754 0 0 1 0-1.06l20-20c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-20 20c-.15.15-.34.22-.53.22s-.38-.07-.53-.22zM17.12 22.25l-6.52-4.07a.747.747 0 1 1 .79-1.27l6.49 4.05c.56.31 1.12.38 1.48.17.36-.21.57-.73.57-1.42v-11c0-.41.34-.75.75-.75s.75.34.75.75v11c0 1.23-.48 2.22-1.31 2.71-.37.22-.79.33-1.24.33-.56 0-1.16-.17-1.76-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.57 19.95V5.86c0-2.54 2.07-4.61 4.61-4.61h9.65c1.39 0 2.7.62 3.58 1.71.26.32.21.79-.11 1.06-.32.26-.79.21-1.05-.11a3.1 3.1 0 0 0-2.42-1.16H7.18a3.12 3.12 0 0 0-3.11 3.11v14.09c0 .41-.34.75-.75.75s-.75-.34-.75-.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineArchiveSlash);
export default __webpack_public_path__ + "static/media/vuesax-outline-archive-slash.4ef5057d7674ac4003a78c39d706eb2e.svg";
export { ForwardRef as ReactComponent };